/**
 * 固定路由
 * 这些路由不需要权限控制，所有用户都可访问
 */
import type { RouteRecordRaw } from "vue-router";

export const constantRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      hidden: true,
      title: "login.title",
    },
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("@/views/error/404.vue"),
    meta: {
      hidden: true,
      title: "404",
    },
  },
  {
    path: "/403",
    name: "Forbidden",
    component: () => import("@/views/error/403.vue"),
    meta: {
      hidden: true,
      title: "403",
    },
  },
  {
    path: "/device",
    name: "DeviceRoot",
    component: () => import("@/layouts/index.vue"),
    meta: { hidden: true },
    children: [
      {
        path: "detail/:fingerprintHash",
        name: "DeviceDetailLocal",
        component: () => import("@/views/device/detail.vue"),
        meta: {
          hidden: true,
          title: "device_detail",
        },
      },
    ],
  },
  {
    path: "/task",
    name: "TaskRoot",
    component: () => import("@/layouts/index.vue"),
    meta: { hidden: true },
    children: [
      {
        path: "detail/:id",
        name: "TaskDetailLocal",
        component: () => import("@/views/task/detail.vue"),
        meta: {
          hidden: true,
          title: "task_detail",
        },
      },
    ],
  },
  {
    path: "/redirect",
    name: "Redirect",
    component: () => import("@/views/redirect/index.vue"),
    meta: {
      hidden: true,
      title: "Redirect",
    },
  },
  // 根路由占位符 - 动态路由加载后会被覆盖
  {
    path: "/",
    name: "Root",
    component: () => import("@/views/redirect/index.vue"),
    meta: {
      hidden: true,
    },
  },
];
